/*
* Sort array
* @param {Array} array - The array to be sorted.
* @param {string} sortKey - Property name to sort the array.
* @param {bool} sortAsc - Sort in ascendent form.
* @returns {Array}
*/
export const sort = (array: Record<string, string>[], sortKey: string, sortAsc = true) => {
  const sortOrder = sortAsc ? 1 : -1;

  return (array.sort(
    (a, b) => (a[sortKey] > b[sortKey]
      ? sortOrder
      : -sortOrder)
  ));
};
